"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscribeOptionLabel = void 0;
var _icons = require("@ori-ui/icons");
var _presentationHooks = require("@ori/presentation-hooks");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../../../hooks");
var _SubscriptionInfo = require("../SubscriptionInfo");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SubscribeOptionLabel = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    onClose,
    onOpen,
    open
  } = (0, _presentationHooks.useDisclose)();
  const onClick = (0, _react.useCallback)(event => {
    event.preventDefault();
    onOpen();
  }, [onOpen]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
      "data-testid": getTestId(_constants.SUBSCRIBE_OPTION_LABEL),
      children: [translations.subscribeOption, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.InfoCircleWrapper, {
        onClick: onClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.InfoCircle, {})
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscriptionInfo.SubscriptionInfo, {
      open: open,
      onClose: onClose
    })]
  });
};
exports.SubscribeOptionLabel = SubscribeOptionLabel;
//# sourceMappingURL=SubscribeOptionLabel.js.map